import { render, staticRenderFns } from "./BotaoMonitoramentoSocioambiental.vue?vue&type=template&id=aa07a768&lang=pug"
import script from "./BotaoMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./BotaoMonitoramentoSocioambiental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports